export default {
    name: 'Nome',
    tel: 'Telefono',
    save: 'Salva',
    confirm: 'Conferma',
    cancel: 'Annulla',
    delete: 'Elimina',
    complete: 'Completa',
    loading: 'Caricamento...',
    telEmpty: 'Inserisci il numero di telefono',
    nameEmpty: 'Inserisci il nome',
    nameInvalid: 'Nome non valido',
    confirmDelete: 'Sei sicuro di voler eliminare?',
    telInvalid: 'Numero di telefono non valido',
    vanCalendar: {
        end: 'Fine',
        start: 'Inizio',
        title: 'Calendario',
        startEnd: 'Inizio/Fine',
        weekdays: ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'],
        monthTitle: function monthTitle(year, month) {
            return year + "/" + month;
        },
        rangePrompt: function rangePrompt(maxRange) {
            return "Seleziona non più di " + maxRange + " giorni";
        }
    },
    vanCascader: {
        select: 'Seleziona'
    },
    vanContactCard: {
        addText: 'Aggiungi contatto'
    },
    vanContactList: {
        addText: 'Aggiungi nuovo contatto'
    },
    vanPagination: {
        prev: 'Precedente',
        next: 'Successivo'
    },
    vanPullRefresh: {
        pulling: 'Tira per aggiornare...',
        loosing: 'Rilascia per aggiornare...'
    },
    vanSubmitBar: {
        label: 'Totale: '
    },
    vanCoupon: {
        unlimited: 'Illimitato',
        discount: function discount(_discount) {
            return _discount * 10 + "% di sconto";
        },
        condition: function condition(_condition) {
            return "Almeno " + _condition;
        }
    },
    vanCouponCell: {
        title: 'Coupon',
        tips: 'Nessun coupon',
        count: function count(_count) {
            return "Hai " + _count + " coupon";
        }
    },
    vanCouponList: {
        empty: 'Nessun coupon',
        exchange: 'Scambia',
        close: 'Chiudi',
        enable: 'Disponibile',
        disabled: 'Non disponibile',
        placeholder: 'Codice coupon'
    },
    vanAddressEdit: {
        area: 'Area',
        postal: 'CAP',
        areaEmpty: 'Seleziona un\'area di consegna',
        addressEmpty: 'L\'indirizzo non può essere vuoto',
        postalEmpty: 'CAP non valido',
        defaultAddress: 'Imposta come indirizzo predefinito',
        telPlaceholder: 'Telefono',
        namePlaceholder: 'Nome',
        areaPlaceholder: 'Area'
    },
    vanAddressEditDetail: {
        label: 'Indirizzo',
        placeholder: 'Indirizzo'
    },
    vanAddressList: {
        add: 'Aggiungi nuovo indirizzo'
    }
};